// extracted by mini-css-extract-plugin
export default {"Icon":"_Icon--o7sX1","Header":"_Header--H2KGb","Contact":"_Contact--FX2kQ"};